// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"ix_a bhv_je","CommentListPlaceholder--Legacy":"ix_b bhv_qh bhv_vk"};